import { ICustomField } from '../services/custom-field/custom-field.model'
import moment from 'moment'
import { isEtsGroupId } from './group-ids-utils'

export function formatTransaction(values: any, groupId: string, addCustomFields: boolean, customFields?: ICustomField[], categoryId?: string) {
  if (values.startDate) {
    values.startDate = moment(values.startDate).format('YYYY-MM-DD')
  }
  if (values.endDate) {
    values.endDate = moment(values.endDate).format('YYYY-MM-DD')
  }
  if (values.invoiceDate) {
    values.invoiceDate = moment(values.invoiceDate).format('YYYY-MM-DD')
  }
  if (values.groupId === '') {
    values.groupId = null
  }
  if (values.returnId === '') {
    values.returnId = null
  }
  if (values.ruleId === '') {
    values.ruleId = null
  }
  if (values.detailLevelThree === '') {
    values.detailLevelThree = null
  }
  if (values.detailLevelFour === '') {
    values.detailLevelFour = null
  }
  if (values.detailLevelFive === '') {
    values.detailLevelFive = null
  }
  if (values.regulatedEmissionTradingSchemeId === '' || !isEtsGroupId(groupId)) {
    values.regulatedEmissionTradingSchemeId = null
  }
  if (values.projectId === '') {
    values.projectId = null
  }
  if (values.contactSupplierId === '') {
    values.contactSupplierId = null
  }
  if (values.locationId === '') {
    values.locationId = null
  }
  if (values.vehicleId === '') {
    values.vehicleId = null
  }
  if (values.capitalGoodId === '') {
    values.capitalGoodId = null
  }
  if (values.categoryId === '') {
    values.categoryId = null
  }
  if (!(groupId === 'acf9ae04-25d9-43d7-b442-fabd69e5844b' && categoryId === 'df026bd9-281d-4013-80e4-a1ef92965502')) {
    values.customMarketBasedMultiplier = null
  }
  if (values.customMarketBasedMultiplier === '') {
    values.customMarketBasedMultiplier = null
  }
  // Certificates apply to electricity (scope-2 Purchased Energy / Electricity) and to gas
  // (scope-1 Company Facilities / Fuels — RGGO). Strip the ids for any other context; the backend
  // further restricts gas eligibility to natural-gas conversions.
  const isElectricityRecContext = groupId === 'acf9ae04-25d9-43d7-b442-fabd69e5844b' && categoryId === 'df026bd9-281d-4013-80e4-a1ef92965502'
  const isGasRggoContext = groupId === '22cc8b45-aa77-49aa-8fb2-c39bb884fa13' && categoryId === 'f88cd55e-9e30-4605-8106-24a53e0b5f62'
  if (!(isElectricityRecContext || isGasRggoContext)) {
    values.renewableEnergyCertificateIds = []
  }
  if (Array.isArray(values.renewableEnergyCertificateIds) && values.renewableEnergyCertificateIds.length === 0) {
    values.renewableEnergyCertificateIds = []
  }
  if (values.energySupplierTariffId === '') {
    values.energySupplierTariffId = null
  }
  if (addCustomFields && customFields) {
    const customFieldValues = Array.isArray(customFields)
      ? customFields.map((field) => {
        const raw = values?.[field.id]
        const value = raw === '' || raw === undefined ? null : raw
        return {
          customFieldId: field.id,
          value
        }
      })
      : [];
    return {
      ...values,
      customFieldValues
    }
  } else {
    return values;
  }
}